"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSanitizedFieldName = exports.handleUnexpectedSanitizeErrors = exports.isSanitizedTapeSuccess = exports.isSanitizedTapeFailure = exports.isRequiredBaseFieldConfig = exports.getSantizedTapeErrorSummary = exports.getCompactedDataTapeErrors = exports.getSanitizedDataTapeField = exports.toColumnInfo = exports.transformDataTapeDefinition = exports.transformDataTape = exports.sanitizeTape = exports.validateTapeFilename = exports.generateXlsx2CsvExtractConfigFromXLSX = exports.generateTapeDefinitionFromCSV = void 0;
const lodash_1 = __importDefault(require("lodash"));
const luxon_1 = require("luxon");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const attachHeader_transform_1 = __importDefault(require("./attachHeader-transform"));
const edit_transform_1 = __importDefault(require("./edit-transform"));
const filter_transform_1 = __importDefault(require("./filter-transform"));
const flatten_transform_1 = __importDefault(require("./flatten-transform"));
const helpers_1 = require("./helpers");
Object.defineProperty(exports, "getCompactedDataTapeErrors", { enumerable: true, get: function () { return helpers_1.getCompactedDataTapeErrors; } });
Object.defineProperty(exports, "getSanitizedDataTapeField", { enumerable: true, get: function () { return helpers_1.getSanitizedDataTapeField; } });
Object.defineProperty(exports, "getSantizedTapeErrorSummary", { enumerable: true, get: function () { return helpers_1.getSantizedTapeErrorSummary; } });
Object.defineProperty(exports, "handleUnexpectedSanitizeErrors", { enumerable: true, get: function () { return helpers_1.handleUnexpectedSanitizeErrors; } });
Object.defineProperty(exports, "getSanitizedFieldName", { enumerable: true, get: function () { return helpers_1.getSanitizedFieldName; } });
const pdf2csv_1 = __importDefault(require("./pdf2csv"));
const preFilter_transform_1 = __importDefault(require("./preFilter-transform"));
const typeguards_1 = require("./typeguards");
Object.defineProperty(exports, "isRequiredBaseFieldConfig", { enumerable: true, get: function () { return typeguards_1.isRequiredBaseFieldConfig; } });
Object.defineProperty(exports, "isSanitizedTapeFailure", { enumerable: true, get: function () { return typeguards_1.isSanitizedTapeFailure; } });
Object.defineProperty(exports, "isSanitizedTapeSuccess", { enumerable: true, get: function () { return typeguards_1.isSanitizedTapeSuccess; } });
const unzip_transform_1 = __importDefault(require("./unzip-transform"));
const xlsx2csv_1 = __importDefault(require("./xlsx2csv"));
var generateTapeDefinition_1 = require("./generateTapeDefinition");
Object.defineProperty(exports, "generateTapeDefinitionFromCSV", { enumerable: true, get: function () { return generateTapeDefinition_1.generateTapeDefinitionFromCSV; } });
Object.defineProperty(exports, "generateXlsx2CsvExtractConfigFromXLSX", { enumerable: true, get: function () { return generateTapeDefinition_1.generateXlsx2CsvExtractConfigFromXLSX; } });
const getCompactErrorResult = (errors) => {
    (0, helpers_1.handleUnexpectedSanitizeErrors)(errors, 'Unexpected legacy data sanitization error');
    const result = {
        isValid: false,
        errors: (0, helpers_1.getCompactedDataTapeErrors)(errors),
        message: (0, helpers_1.getSantizedTapeErrorSummary)(errors),
    };
    return result;
};
const validateTapeFilename = (filename, baseFilename) => {
    const regexStr = `^${baseFilename}-(\\d{4}-\\d{2}-\\d{2})(?:-v(\\d+))?$`;
    const regex = new RegExp(regexStr);
    const matches = regex.exec(filename);
    if (matches === null) {
        return { isValid: false };
    }
    return {
        isValid: true,
        reportingDate: matches[1],
        version: parseInt(matches[2], 10) || 1,
    };
};
exports.validateTapeFilename = validateTapeFilename;
const sanitizeTape = ({ csv, baseFieldConfig, externalReferenceIdField, 
// if assignmentFilter is not specified
// we will use a default filter that returns true for all rows.
assignmentFilter = () => true, delimiter = ',', sanitizeFieldNames = true, }) => __awaiter(void 0, void 0, void 0, function* () {
    let headers;
    let csvArray;
    try {
        const { originalHeaders, csvArray: preAssignCsvArray, } = common_1.csvConversion.finleyBufferToCsvArray({
            buffer: csv,
            delimiter,
            headerRenameFunction: (rawHeader) => (0, helpers_1.getSanitizedFieldName)(rawHeader, sanitizeFieldNames),
        });
        // Validate no duplicates prior to handling by Papa parse
        const errors = (0, helpers_1.validateHeaders)({
            headers: originalHeaders,
            externalIdField: externalReferenceIdField,
        });
        if (errors.length) {
            throw errors;
        }
        headers = Object.keys(preAssignCsvArray[0]);
        csvArray = preAssignCsvArray.filter(assignmentFilter);
    }
    catch (errors) {
        return getCompactErrorResult(errors);
    }
    const preSanitized = lodash_1.default.includes(headers, 'finley_sanitized');
    try {
        const data = (0, helpers_1.getSanitizedCsvData)({
            csvArray,
            baseFieldConfig,
            externalReferenceIdField,
            preSanitized,
        });
        return { isValid: true, data };
    }
    catch (errors) {
        return getCompactErrorResult(errors);
    }
});
exports.sanitizeTape = sanitizeTape;
const transformDataTape = ({ srcDataTapeBuffer, joinDataTapeBuffer, transformation, pdfExtractor, }) => {
    switch (transformation.operation) {
        case 'attachHeader': {
            return attachHeader_transform_1.default.doTransform({
                srcDataTapeBuffer,
                transformation,
            });
        }
        case 'xlsx2csv': {
            return xlsx2csv_1.default.doTransform({
                xlsBuffer: srcDataTapeBuffer,
                transformation,
            });
        }
        case 'join':
            (0, common_1.finleyAssert)(joinDataTapeBuffer, 'joinDataTapeBuffer is required');
            return (0, helpers_1.joinTransformOp)({
                srcDataTapeBuffer,
                joinDataTapeBuffer,
                transformation,
            });
        case 'sanitize':
            return (0, helpers_1.sanitizeTransformOp)({ srcDataTapeBuffer, transformation });
        case 'edit':
            return edit_transform_1.default.doTransform({ srcDataTapeBuffer, transformation });
        case 'flatten':
            return flatten_transform_1.default.doTransform({
                srcDataTapeBuffer,
                transformation,
            });
        case 'filter':
            return filter_transform_1.default.doTransform({ srcDataTapeBuffer, transformation });
        case 'pdf2csv':
            return pdf2csv_1.default.doTransform({
                srcDataTapeBuffer,
                transformation,
                pdfExtractor,
            });
        case 'preFilter':
            return preFilter_transform_1.default.doTransform({
                srcDataTapeBuffer,
                transformation,
            });
        case 'unzip':
            return unzip_transform_1.default.doTransform({
                srcDataTapeBuffer,
                transformation,
            });
        default:
            return (0, common_1.finleyAssertUnreachable)(transformation);
    }
};
exports.transformDataTape = transformDataTape;
const transformDataTapeDefinition = (transformation) => {
    let dataTape;
    try {
        switch (transformation.operation) {
            case 'attachHeader':
                dataTape = attachHeader_transform_1.default.validateAttachHeaderConfig(transformation);
                break;
            case 'xlsx2csv':
                dataTape = xlsx2csv_1.default.validateXlsToCSVConfig(transformation);
                break;
            case 'pdf2csv':
                dataTape = pdf2csv_1.default.validatePdf2CsvConfig(transformation);
                break;
            case 'preFilter':
                dataTape = preFilter_transform_1.default.validatePreFilterConfig(transformation);
                break;
            case 'join':
                dataTape = (0, helpers_1.getJoinTransformOpOutputDataTape)(transformation);
                break;
            case 'sanitize':
                dataTape = (0, helpers_1.getSanitizeTransformOpOutputDataTape)(transformation);
                break;
            case 'edit':
                dataTape = edit_transform_1.default.getOutputDataTape(transformation);
                break;
            case 'flatten':
                dataTape = flatten_transform_1.default.getOutputDataTape(transformation);
                break;
            case 'filter':
                dataTape = filter_transform_1.default.getOutputDataTape(transformation);
                break;
            case 'unzip':
                dataTape = unzip_transform_1.default.validateUnzipConfig(transformation);
                break;
            default:
                return (0, common_1.finleyAssertUnreachable)(transformation);
        }
    }
    catch (err) {
        // this assert seems too strict
        (0, common_1.finleyAssert)(lodash_1.default.isArray(err), err);
        return { isValid: false, errors: err };
    }
    return { isValid: true, data: dataTape };
};
exports.transformDataTapeDefinition = transformDataTapeDefinition;
const toColumnInfo = (baseConfig) => {
    var _a;
    let type;
    let examples;
    switch (baseConfig.type) {
        case 'boolean':
        case 'optionalBoolean':
            type = 'boolean';
            examples = [baseConfig.externalBooleanTrue];
            break;
        case 'currency':
        case 'optionalCurrency':
            type = 'currency';
            switch (baseConfig.currencyCode) {
                case finley_types_1.Bank.Currency.USD:
                case finley_types_1.Bank.Currency.CAD:
                case finley_types_1.Bank.Currency.MXN:
                case finley_types_1.Bank.Currency.EUR:
                case finley_types_1.Bank.Currency.GBP:
                    examples = ['$100.00', '100', '-100.00', '(100)'];
                    break;
                default:
                    return (0, common_1.finleyAssertUnreachable)(baseConfig.currencyCode);
            }
            break;
        case 'date':
        case 'optionalDate': {
            type = 'date';
            // Select representative dates:
            // - 1999 is unambiguously a year, even when abbreviated
            // - 31 is unambiguously a date
            // - 01 demonstrates zero-padding behavior
            examples = [
                luxon_1.DateTime.fromObject({
                    year: 1999,
                    month: 1,
                    day: 1,
                }).toFormat(baseConfig.externalDateFormat),
                luxon_1.DateTime.fromObject({
                    year: 1999,
                    month: 1,
                    day: 31,
                }).toFormat(baseConfig.externalDateFormat),
            ];
            break;
        }
        case 'dateTime':
        case 'optionalDateTime': {
            type = 'date/time';
            // Select representative dates:
            // - 1999 is unambiguously a year, even when abbreviated
            // - 31 is unambiguously a date
            // - 01 demonstrates zero-padding behavior
            // - Also demonstrate eastern time vs UTC
            examples = [
                luxon_1.DateTime.fromObject({
                    year: 1999,
                    month: 1,
                    day: 1,
                    hour: 10,
                    minute: 45,
                }).toFormat(baseConfig.externalDateTimeFormat),
                luxon_1.DateTime.fromObject({
                    year: 1999,
                    month: 1,
                    day: 31,
                    hour: 10,
                    minute: 45,
                    zone: 'UTC',
                }).toFormat(baseConfig.externalDateTimeFormat),
            ];
            break;
        }
        case 'float':
        case 'optionalFloat':
            type = 'float (decimal numbers)';
            examples = ['100', '100.0', '-100.0'];
            break;
        case 'integer':
        case 'optionalInteger':
            type = 'integer (whole numbers)';
            examples = ['100', '-100'];
            break;
        case 'percentage':
        case 'optionalPercentage':
            type = 'percentage';
            examples = ['10%', '10.00%', '10.0'];
            break;
        case 'string':
        case 'optionalString':
            type = 'text';
            examples = []; // Too open-ended to provide guidance. We'll rely on the description field.
            break;
        default:
            return (0, common_1.finleyAssertUnreachable)(baseConfig);
    }
    return {
        name: baseConfig.field,
        // If a default value is specified, report the field as optional.
        required: (0, typeguards_1.isRequiredBaseFieldConfig)(baseConfig) && lodash_1.default.isNil(baseConfig.defaultTo),
        type,
        description: (_a = baseConfig.description) !== null && _a !== void 0 ? _a : '',
        examples,
        defaultValue: (0, typeguards_1.isRequiredBaseFieldConfig)(baseConfig) && !lodash_1.default.isNil(baseConfig.defaultTo)
            ? baseConfig.defaultTo
            : null,
    };
};
exports.toColumnInfo = toColumnInfo;
//# sourceMappingURL=index.js.map